<template>
  <ValidationObserver ref="observer1" v-slot="{ handleSubmit1 }">
    <form class="mt-n3" @submit.prevent="handleSubmit1(onSubmit1)">
      <div class="row">
        <div class="col-md-8 col-sm col-12 h-100 mb-n4">
          <breadcrumb :page="page" />
        </div>
        <div class="col-md-4 col-sm text-right mt-1 mt-md-5 mt-sm-1">
          <ActionButton
            variant="outline-success mr-1"
            i="fas fa-arrow-circle-left"
            @click="goBack"
          >
            Regresar
          </ActionButton>
          <ActionButton
            :class="!isEnabled ? 'disabled-page' : ''"
            type="submit"
            variant="success"
            i="fas fa-save"
            @click="onSubmit1"
          >
            Guardar
          </ActionButton>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="dropdown-divider pb-3 w-100" />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <SectionTitle :content="'Traslados'" :has-line="true" />
          <div class="row">
            <div class="col col-sm col-12 mr-5">
              <ValidationProvider
                v-slot="{ errors }"
                mode="eager"
                rules="required"
              >
                <CustomDropDown
                  v-model="model.schoolType"
                  :error="errors[0]"
                  :custom-error-msg="getError('21009')"
                  :options="schoolTypes"
                  fieldkey="id"
                  fieldname="name"
                  label="Tipo de Escuela:"
                  placeholder="Seleccione"
                  class="block-spacing"
                  @input="onChange('schoolType', $event)"
                />
              </ValidationProvider>
            </div>
            <div class="col col-sm col-12 mr-5">
              <ValidationProvider
                v-slot="{ errors }"
                mode="eager"
                rules="required"
              >
                <CustomDropDown
                  v-model="model.region"
                  :error="errors[0]"
                  :custom-error-msg="getError('21006')"
                  :options="regions"
                  fieldkey="id"
                  fieldname="name"
                  label="Región:"
                  placeholder="Seleccione"
                  class="block-spacing"
                  @input="onChange('region', $event)"
                />
              </ValidationProvider>
            </div>
            <div class="col col-sm col-12 mr-5">
              <ValidationProvider
                v-slot="{ errors }"
                mode="eager"
                rules="required"
              >
                <CustomDropDown
                  v-model="model.district"
                  :error="errors[0]"
                  :custom-error-msg="getError('21007')"
                  :options="districts"
                  fieldkey="id"
                  fieldname="name"
                  label="Distrito:"
                  placeholder="Seleccione"
                  class="block-spacing"
                  @input="onChange('district', $event)"
                />
              </ValidationProvider>
            </div>
            <div class="col col-sm col-12">
              <ValidationProvider
                v-slot="{ errors }"
                mode="eager"
                rules="required"
              >
                <CustomDropDown
                  v-model="model.school"
                  :error="errors[0]"
                  :custom-error-msg="getError('21008')"
                  :options="schools"
                  fieldkey="id"
                  fieldname="name"
                  label="Escuela:"
                  placeholder="Seleccione"
                  class="block-spacing"
                  placement-top
                />
              </ValidationProvider>
            </div>
          </div>
          <div class="row">
            <div class="col col-sm col-12 mr-5">
              <ValidationProvider
                v-slot="{ errors }"
                mode="eager"
                rules="required"
              >
                <CustomDropDown
                  v-model="model.residence"
                  :error="errors[0]"
                  :custom-error-msg="getError('22162')"
                  :options="residences"
                  fieldkey="id"
                  fieldname="name"
                  label="Residencia:"
                  placeholder="Seleccione"
                  class="block-spacing"
                />
              </ValidationProvider>
            </div>
            <div class="col col-sm col-12 mr-5">
              <transition name="fade">
                <div class="calendar-fixed-size">
                  <ValidationProvider
                    v-slot="{ errors }"
                    mode="eager"
                    :disabled="!showDate"
                    :rules="`${showDate ? 'required' : ''}`"
                  >
                    <CustomDatePicker
                      v-if="showDate"
                      v-model="model.date"
                      required
                      :label="'Fecha'"
                      :error="errors[0]"
                      :custom-error-msg="'Fecha: La fecha es requerida.'"
                      :disabled="canEditDates"
                    />
                  </ValidationProvider>
                </div>
              </transition>
            </div>
            <div class="col col-sm col-12 mr-5">
              <transition name="fade">
                <ValidationProvider
                  v-slot="{ errors }"
                  mode="eager"
                  :disabled="!showServices"
                  :rules="`${showServices ? 'required' : ''}`"
                >
                  <CustomDropDown
                    v-if="showServices"
                    v-model="model.service"
                    :error="errors[0]"
                    :custom-error-msg="getError('8003')"
                    :options="services"
                    fieldkey="id"
                    fieldname="name"
                    label="Servicios:"
                    placeholder="Seleccione"
                    class="block-spacing"
                    @input="onChange('services', $event)"
                  />
                </ValidationProvider>
              </transition>
            </div>
            <div class="col" />
          </div>
          <div class="row mt-n5 mt-md-n1">
            <div class="col col-sm col-12">
              <ValidationProvider
                v-slot="{ errors }"
                mode="eager"
                rules="required"
              >
                <CustomTextArea
                  :id="'transferComment'"
                  v-model="model.comment"
                  :error="errors[0]"
                  :custom-error-msg="getError('17306')"
                  style="width:100%"
                  :maxlength="500"
                  :classes="['eq-field', 'text-left']"
                  :label="'Comentario:'"
                  :rows="5"
                  :disabled="false"
                />
              </ValidationProvider>
            </div>
          </div>
        </div>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import breadcrumb from "@/components/common/page/TitleBreadcrumb";
import { SectionTitle } from "@/components/pei/shared";
import CustomDatePicker from "@/components/common/CustomDatePicker";
import { ActionButton, CustomDropDown } from "@/components/common";

import CustomTextArea from "@/components/common/CustomTextArea";
import { ValidationObserver } from "vee-validate";
import resourcesService from "@/services/resources.js";
import schoolTypes from "@/utils/constants/student/schoolTypes.js";
import viewTypes from "@/utils/constants/comment/CodeViewTypes.js";
import store from "@/store/index";
import alert from "@/mixin/alert.mixin";

const initialState = {
  school: null,
  district: null,
  region: null,
  service: null,
  date: new Date(),
  residence: null,
  schoolType: null,
  comment: null
};

export default {
  name: "AddEditTransfers",
  components: {
    breadcrumb,
    SectionTitle,
    ActionButton,
    CustomDatePicker,
    CustomDropDown,
    CustomTextArea,
    ValidationObserver
  },
  mixins: [alert],
  data() {
    return {
      page: {
        icon: "fas fa-user-circle",
        title: "Traslado de Estudiantes Privados",
        routes: [
          "Inicio",
          "Estudiante",
          "Traslado",
          "Traslado de Estudiantes Privados"
        ]
      },
      schoolTypes: [],
      regions: [],
      districts: [],
      residences: [],
      schools: [],
      services: [],
      resources: [],
      showDate: false,
      showServices: false,
      canEditDates: false,
      isEnabled: false,
      model: { ...initialState }
    };
  },
  created() {
    this.loadResources();
  },
  mounted() {
    this.getSchoolTypes().then(() => {
      this.getResidences();
    });
  },
  methods: {
    async getSchoolTypes() {
      return await this.$ApiGet(
        `/api/schools/locationTypes/${viewTypes.Transfer}`
      ).then(res => {
        this.schoolTypes = this.orderAlphabetically(res.data, "name").filter(
          x => x.id != schoolTypes.PublicSchool
        );
      });
    },
    async getDistricts(regionId) {
      await this.$ApiGet(`/api/schools/types/regions/districts`, {
        SchoolTypes: this.model.schoolType.id,
        RegionId: regionId
      }).then(res => {
        this.districts = this.orderAlphabetically(res.data, "name");
      });
    },
    async getRegions(schoolTypeId) {
      await this.$ApiGet(`/api/schools/types/regions`, {
        SchoolTypes: schoolTypeId
      }).then(res => {
        this.regions = this.orderAlphabetically(res.data, "name");
      });
    },
    async getServices(schoolTypeId) {
      await this.$ApiGet(
        `/api/schools/types/services?schoolTypeId=${schoolTypeId}`
      ).then(res => {
        this.services = this.orderAlphabetically(res.data, "name");
      });
    },
    async getResidences() {
      await this.$ApiGet("/api/schools/municipalities").then(res => {
        this.residences = this.orderAlphabetically(res.data, "name");
      });
    },
    async getSchools(districtId) {
      await this.$ApiGet(`/api/schools/`, {
        SchoolTypes: this.model.schoolType.id,
        DistrictId: districtId
      }).then(res => {
        this.schools = this.orderAlphabetically(res.data, "name");
      });
    },

    onChange(selectedType, selectedValue) {
      if (selectedType === "schoolType") {
                
        const schoolTypesWithValidationOfAge = [
          schoolTypes.Home, 
          schoolTypes.HeadStart, 
          schoolTypes.CareCenter
        ]

        if(schoolTypesWithValidationOfAge.includes(this.model.schoolType?.id) && Math.floor(store.getters.SelectedStudent.age) >= 7)
        {
          this.ShowToast('Alerta', 'No es posible seleccionar ya que el estudiante es mayor de 6 años.', 'error');
          this.model.schoolType = null;
          return;
        }        

        this.model.region = null;
        this.model.district = null;
        this.model.school = null;
        this.model.service = null;

        this.getRegions(selectedValue.id);
        if (
          selectedValue.id === schoolTypes.PrivateSchool ||
          selectedValue.id === schoolTypes.Institutions
        ) {
          this.getServices(selectedValue.id);
          this.showDate = true;
          this.showServices = true;
        } else {
          this.showDate = false;
          this.showServices = false;
        }
      }
      if (selectedType === "region") {
        this.model.district = null;
        this.model.school = null;
        this.getDistricts(selectedValue.id);
      } else if (selectedType === "district") {
        this.model.school = null;

        this.getSchools(selectedValue.id);
      }
    },
    orderAlphabetically(array, prop) {
      return array.sort((a, b) => a[prop].localeCompare(b[prop]));
    },
    getError(code) {
      let message = this.resources[code];

      return message ? message.replace(`(${code})`, "") : "";
    },
    goBack() {
      this.$router.push({ path: "/student/transferhistory" });
    },
    async loadResources() {
      this.resources = await resourcesService.LoadValidationMessages([
        "21009",
        "21006",
        "21007",
        "21008",
        "17306",
        "22162",
        "8003"
      ]);
    },

    async onSubmit1() {
      const isValid = await this.$refs.observer1.validate();

      if (isValid) {
        let studentSieId = store.getters.SelectedStudent.studentId;
        let StudentTransferRequestDTO = {
          destinationLocationSchoolId: this.model.school.id,
          locationResidenceMunicipalityId: this.model.residence.id,
          transferStartDate: this.showDate
            ? this.model.date.toISOString()
            : null,
          institutionServiceCodeId: this.model.service
            ? this.model.service.id
            : null,
          comments: this.model.comment
        };
        await this.$ApiPost(
          `/api/student/${studentSieId}/transfer`,
          StudentTransferRequestDTO
        )
          .then(() => {
            alert.methods.ShowToast(
              "",
              "Las respuestas fueron guardadas satisfactoriamente",
              "success"
            );
            this.$router.push({ name: "TransferHistory" });
          })
          .catch(err => {
            if (err && err.response && err.response.data) {
              alert.methods.ShowToast(
                "Alerta",
                err.response.data.message,
                "warning"
              );
            } else {
              alert.methods.ShowToast("Error", err.message, "error");
            }
          });
      }
    }
  }
};
</script>

<style scoped>
.table-W .col-2,
.col-12 {
  padding: 18px 38px;
}
.row .col-12 {
  padding-left: 10px;
}
.row .col {
  margin-left: 1.2%;
}
.textarea-edge {
  border: 1px solid #e2e2e2;
}
.control-input {
  margin-top: -1%;
  width: 100%;
  border: 1.1px solid #e2e2e2;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.validation-error {
  background: #f9d4da;
  border: 1px solid #de6874;
  color: black;
}
</style>
